import React, { memo } from 'react';
import { Button, Divider, Flex, Text } from '@mantine/core';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useNavigate } from 'react-router-dom';
import { DataGeneratableDocumentTemplateWithAllRelationsTct } from '@dealstack/shared/lib/generated';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable';
import { GENERATABLE_DOCUMENTS_TABLE_COLUMNS } from '@dealstack/frontend/admin/pages/Manage/ManageGeneratableDocuments/GeneratableDocumentsTable/columns.tsx';
import { useMantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperations';

interface Props {
	documentsTemplates?: DataGeneratableDocumentTemplateWithAllRelationsTct[];
}

const GeneratableDocumentsTable = ({ documentsTemplates = [] }: Props) => {
	const navigate = useNavigate();

	const mantineTableDataOperations = useMantineTableDataOperations();

	return (
		<div>
			<div style={{ maxHeight: pageHeaderHeight, overflow: 'hidden' }}>
				<Button
					size="sm"
					variant="outline"
					onClick={() => navigate(GODMODE_ROOT_ROUTES.DASHBOARD)}
					leftSection={<Icon variant="arrow-left" />}
				>
					Back to dashboard
				</Button>

				<Flex gap="2rem" align="center" justify="space-between" mt="1rem">
					<Text size="B4Bold">Manage generatable documents templates</Text>
				</Flex>

				<Divider mt="1rem" mb="1rem" />
			</div>
			<MantineTable<DataGeneratableDocumentTemplateWithAllRelationsTct>
				data={documentsTemplates}
				columns={GENERATABLE_DOCUMENTS_TABLE_COLUMNS}
				rowCount={documentsTemplates.length}
				dataOperations={mantineTableDataOperations}
				manualPagination={false}
				manualFiltering={false}
				manualSorting={false}
				enableRowSelection={false}
				renderBulkActionsMenu={false}
			/>
		</div>
	);
};

const pageHeaderHeight = '20rem';
const _GeneratableDocumentsTableExport = memo(GeneratableDocumentsTable);

export { _GeneratableDocumentsTableExport as GeneratableDocumentsTable };
